import Text from '@shared/components/content/text';
import Logo from '@shared/components/logo/logo';

interface SECRReportHeroProps {
  organisationName: string;
  period: string;
  framework?: string;
  standard?: string;
  copySlot?: React.ReactNode;
}

export function SECRReportHero({
  organisationName,
  period,
  framework = 'Streamlined Energy & Carbon Reporting (SECR)',
  standard = 'GHG Protocol Corporate Standard',
  copySlot,
}: SECRReportHeroProps) {
  return (
    <div className="overflow-hidden rounded-xl bg-primary p-12">
      <Logo variant="name" color="light" className="mb-10 w-48" />
      <div className="space-y-1">
        <Text variant="h1" className="font-heading text-3xl text-gray-00">
          {organisationName}
        </Text>
        <Text variant="h1" className="font-heading text-3xl text-teal-400">
          SECR Report
        </Text>
        <Text className="mt-2 text-sm text-gray-00/70">{period}</Text>
      </div>
    </div>
  );
}
